// Detect the user's preferred language from the browser settings
function detectBrowserLanguage(supported = ["en", "es"]) {

  // Get the list of languages from the browser, or fallback to navigator.language
  const list = ((navigator.languages && navigator.languages.length)
    ? navigator.languages
    : [navigator.language || ""]
  ).map((l) => l.toLowerCase().substring(0, 2));

  // Return the first language that is supported, or fallback to "en"
  for (const lang of list)
    if (supported.includes(lang)) return lang;

  return "en";
}

// Get the user's language preference from localStorage, or detect it from the browser
function getUserLanguage(supported = ["en", "es"]) {
  let stored = localStorage.getItem("language") || "auto";
  if (supported.includes(stored)) return stored;
  return detectBrowserLanguage(supported);
}

export { detectBrowserLanguage, getUserLanguage };
